import moment from "moment";

function validDateFormat(value) {
    const pattern = /^(?:19|20|21)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))$/
    return pattern.test(value);
}

export const validationMixin = {
    data() {
        return {
            rules: {
                required: value => {
                    if (value === undefined)
                        return 'Required';
                    if (value === '')
                        return 'Required';
                    if (!value)
                        return 'Required';

                    return true;
                },
                mobileLength: value => {
                    if (value !== undefined  && value.length >10)
                        return "Mobile number should be maximum of 10 character"

                    return  true;

                },
                number:value => {
                    if (value !== undefined &&   /\D/.test(value)){
                        return "Value should be number only"
                    }
                    return true;
                },
                invoice_number:value =>{
                    if (value !== undefined &&   !/^[0-9-/]*$/.test(value)){
                        return "Invalid format of invoice number. (Accept these formats only 2077-1111, 201212, 2066/111)"
                    }
                    return true
                },
                interpol_alert_number:value => {
                    if (value !== undefined && !/^[0-9-/][,0-9-/]*$/.test(value)){
                        return "Invalid format of interpol alert mobile number."
                    }
                    return true
                },
                interpol_alert_email:value => {
                    if (value !== undefined && !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([,]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/.test(value) ){
                        return "Invalid format of interpol alert email."
                    }
                    return true
                },
                multipleRequired: value => {
                    if (value !== undefined && value.length === 0)
                        return 'Required';

                    return true;
                },
                multipleFileRequired: value => {
                    let message = "Required";
                    if (value.length > 0)
                        message = true;
                    return message;
                },
                fileRequired: value => {
                    let message = "Required";
                    if (value) {
                        if (value.name !== undefined)
                            message = true;
                    }
                    return message;
                },
                email: [
                    v => !!v || 'E-mail is required',
                    v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
                ],
                password:
                    v => /(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]){6,}/.test(v) ||
                        'Password must contain one lowercase, one uppercase, one special character and greater than 6 digit'
                //     (/^
                //     (?=.*\d)                //should contain at least one digit
                // (?=.*[a-z])             //should contain at least one lower case
                // (?=.*[A-Z])             //should contain at least one upper case
                // [a-zA-Z0-9]{8,}         //should contain at least 8 from the mentioned characters
                // (?=.*[!#$%&? "]) : Special characters
                // $/)
                ,
                dobValidityDate: value => moment(value).isBefore(moment.now()) || "Date of birth cannot be of the future ",

                beforeTodayEng: value => moment(value).isBefore(moment.now()) || "Date cannot be of future.",

                afterTodayEng: value => {
                    if (value === undefined || value === '')
                        return true;

                    return moment(value).isSameOrAfter(moment.now()) || "Date should be of future";
                },
                minimumDay: value  => value > -1 || "This shouldn't be less than 0.",
                maxStickerNumberLen:value => (value.toString().length === 6 || value.toString().length === 5) || value.toString().length === 7 || "Sticker number should be of length 6",
                maxStickerNumberLenIf:value => {
                    if(value && (value.toString().length > 7 || value.toString().length < 6))
                        return "Sticker number should be of length 6 or 7";
                    return true;
                },
            },
        }
    }
}
